import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of,  } from 'rxjs';
import { shareReplay,map, catchError } from 'rxjs/operators';
import { SearchResult } from '../models/searchResult';
import { IndexDataBox } from '../models/indexDataBox';


@Injectable({
  providedIn: 'root'
})
export class Data2Service {
  REFRESH_INTERVAL = 1000*60*60; //1hr. this value is in ms

  constructor(private http:HttpClient) { } 

  // ---- Index Data Boxes ----
  // Returns one databox per parent_id, in the same order requested. Backend caches ~10s;
  // each databox carries its live time-series-construction segments + definition html.
  // GET https://data2.ifa.com/api/v1/index-data-boxes?parent_ids=884,24943,...
  indexDataBoxes$(parentIds: Array<number | string>): Observable<IndexDataBox[]> {
    const csv = (parentIds ?? []).join(',');
    const url = `https://data2.ifa.com/api/v1/index-data-boxes?parent_ids=${encodeURIComponent(csv)}`;
    return this.http.get<IndexDataBox[]>(url).pipe(
      map((data) => data ?? []),
      catchError((err) => { console.log('error indexDataBoxes', err); return of([] as IndexDataBox[]); })
    );
  }

  //decalrative
  articleVideoWhitelistCheck$(friendlyURL:string):Observable<boolean>{
    return this.http.get(`https://data2.ifa.com/odata/v1/articles/${friendlyURL}/whitelist`)
    .pipe(
      //tap((data:any)=>console.log("portfolio_underlying_mutual_funds$ tap",JSON.stringify(data))),
      map((resp)=>{   
        if(resp==true){
          //console.log(`${friendlyURL} is whitelisted`);
          return true;
        }       
        else{
          //console.log(`${friendlyURL} is NOT whitelisted`);
          return false;
        }
      }),
      //tap((mappedResp:any)=> console.log(mappedResp)),
      catchError(err => {
// $&("There was an error getting 'Article / Video Whitelist' from the backend server. "+friendlyURL); 
        return of(false);
      }),
      shareReplay(120000) //2 min.
    );
  }

    //declarative 
  investment$(query:string=""):Observable<any>{
    return this.http.get(`https://data2.ifa.com/odata/v1/investment${query}`).pipe(catchError(err=>of([])));
  }

    implementationChoicesEquity$():Observable<any>{
    return this.http.get(`https://data2.ifa.com/api/v1/implementations/equity`).pipe(catchError(err=>of([])))
  }
  implementationChoicesFixedIncome$():Observable<any>{
    return this.http.get(`https://data2.ifa.com/api/v1/implementations/fixedincome`).pipe(catchError(err=>of([])))
  }
  implementationPresetMixes$():Observable<any>{
    return this.http.get(`https://data2.ifa.com/api/v1/implementations/preset-mixes`).pipe(catchError(err=>of([])))
  }


  //declarative
  portfolio_underlying_mutual_funds$(portfolio:string):Observable<any>{
    return this.http.get(`https://data2.ifa.com/odata/v1/portfolio-underlying-mutual-funds?portfolio=${portfolio}`)
    .pipe(
      //tap((data:any)=>console.log("portfolio_underlying_mutual_funds$ tap",JSON.stringify(data))),
      map((resp:any)=>{  
        resp.data =  resp.data.map((x:any)=>{         
          x.specific_asset_class=x.general_asset_class_name?.replace(/[_]/g," ");   
          if(x.specific_asset_class){  
            x.general_asset_class_name = x.specific_asset_class
            .replace(/US (Large Cap|Large Value|Large Blend|Mid Cap Blend|Mid Cap Value|Mid Cap|Mid Value|Small Cap Value|Small Cap|Small Value|Small Blend|High Profitability|Core Equity 2)/g,"United States Equities")
            // .replace(/US (Large Cap|Large Value|Large Blend|)/g,"US Large")
            // .replace(/US (Mid Cap Blend|Mid Cap|Mid Value)/g,"US Mid")
            // .replace(/US (Small Cap|Small Value|Small Blend)/g,"US Small")
            .replace(/Global Real Estate/g,"Global Real Estate")
            .replace(/International (Blend|Small Cap Value|Small Cap|Small|Value|Sustainability Core|Social Core|Core Equity 2|Core|High Profitability)/g,"International Equities")
            .replace(/Emerging Markets (Blend|Small Cap|Small|Value|Sustainability Core|Social Core|Core Equity 2|Core|High Profitability)/g,"Emerging Markets Equities")
            .replace(/(One Year|Two Year|Five Year|Short Term Gov|Short Term|Investment Grade|Global Core|Sustainable|Social|Tax Exempt|Short Duration|US Core|Global ex US Core|Global Credit) Fixed Income/g,"Global Fixed Income")
          ;
          }   
          return x;
        });
        //console.log("resp.data", resp.data)
        return resp;
      }),
      //tap((mappedResp:any)=> console.log(mappedResp)),
      catchError(err => of("There was an error getting 'Implementations' from the backend server.",portfolio,err)),
      shareReplay(this.REFRESH_INTERVAL)
    );
  }


     //returns svg definitions for investments:
  //https://data2.ifa.com/api/v1/svgs/definitions?ids=696,697,695
  svgsDefinitions(query:string){
    return this.http.get(`https://data2.ifa.com/api/v1/svgs/definitions/${query}`, { responseType: 'text' });
     //return this.http.get<any>(`https://data2.ifa.com/api/v1/svgs/definitions/${query}`, { responseType: 'text' });
  }

  searchArticles(term: string) : Observable<SearchResult[]> {
    return this.http.get<SearchResult[]> ('https://data2.ifa.com/odata/v1/articles/search/?search=' + term + '&sitegroup=www.investingforcatholics.com').pipe(map((x:SearchResult[])=>{
      
    for(var i=0;i<x.length;i++){
      if(!x[i].posters && !x[i].posterUrl){
        x[i].posterUrl=x[i].imageUrl;
      }
      else if(x[i].posters.length>4){
        x[i].posterUrl=x[i].posters[5].url
      }

        // console.log("x[i]",x[i])
      
      }
      return x;
    }))
  }
   timeSeriesConstructionCurrentAllocation(ids:string=""){
    return this.http.get<any>(`https://data2.ifa.com/odata/v1/time_series_construction/current-allocation/?ids=${ids}`);
   }

  consentLog$(body:any):Observable<any>{
    return this.http.post(`https://data2.ifa.com/api/v1/consent-log`,body).pipe(     
      //catchError(()=>of("error in contact options")),     
    );
  }

  
}
